import decamelizeKeys from 'decamelize-keys';

export const trySegmentCall = <T extends keyof WindowAnalytics>(
  type: T,
  ...args: Parameters<WindowAnalytics[T]>
): void => {
  try {
    // @ts-ignore: Typing with rest and spread created unexpected error, but works
    window.analytics[type](...args);
  } catch (e) {
    console.error(e);
  }
};

export const track = (event: string, properties: Record<string, unknown> = {}): void =>
  trySegmentCall('track', event, decamelizeKeys({ ...properties, product: 'Disability' }));

export const page = (): void => {
  const { pathname, href } = window.location;

  trySegmentCall('page', undefined, pathname, { url: href, path: pathname });
};

export const identify = (uuid?: string, traits: Record<string, unknown> = {}): void =>
  trySegmentCall('identify', uuid, decamelizeKeys(traits));
